console.log('  _____ ____  _      _      ______ _____ _______ _______      ________');
console.log(' / ____/ __ \\| |    | |    |  ____/ ____|__   __|_   _\\ \\    / /  ____|');
console.log(' | |   | |  | | |    | |    | |__ | |       | |    | |  \\ \\  / /| |__');
console.log(' | |   | |  | | |    | |    |  __|| |       | |    | |   \\ \\/ / |  __|');
console.log(' | |___| |__| | |____| |____| |___| |____   | |   _| |_   \\  /  | |____');
console.log(' \\_____\\____/|______|______|______ \\_____|  |_|  |_____|   \\/   |______|');
console.log('');
console.log('Handmade with ♥ By Collective');
console.log('© 2018');
